import httpClient from '@/services/http/httpClient'

export const apiPostViewType = agentViewBody => {
  return httpClient.post('/admin/users/agentView', agentViewBody)
    .then(data => data)
    .catch(error => Promise.reject(error))
}
